export const organizationRoute = "/$orgSlug" as const;
export const newProjectRoute = "/$orgSlug/new-project" as const;
export const projectRoute = "/$orgSlug/$id" as const;
export const projectFileRoute = "/$orgSlug/$id/$" as const;
export const projectSelectRoute = "/$orgSlug/$id/select" as const;
